import type { OrganizationDto } from '@src/api';

import { userStore } from '../../userStore';

export interface OrganizationView extends OrganizationDto {
  key: number | string;
  value: number | string; // это нужно, что бы не вылезал варнинг в анте
  title: string;
  disabled?: boolean;
  disableCreate?: boolean;
  disableEdit?: boolean;
  disableDelete?: boolean;
  label?: string;
  children?: OrganizationView[];
}

export function organizationToViewModel(
  organization: OrganizationDto,
  organizations: OrganizationDto[],
  title?: string,
): OrganizationView {
  const { permissions } = userStore;
  const { code, name } = organization;
  const children = organizations.filter(({ parentCode }) => parentCode === code);

  return {
    ...organization,
    title: title ? (organization as never)[title] : `${code} - ${name}`,
    value: code ?? 0,
    key: code ?? 0,
    disableCreate: !permissions?.CmOrganization?.scopePermissions.CREATE,
    disableEdit: !permissions?.CmOrganization?.scopePermissions.UPDATE,
    disableDelete: !permissions?.CmOrganization?.scopePermissions.DELETE,
    children: children.length
      ? children.map((child) => organizationToViewModel(child, organizations, title))
      : undefined,
  };
}

export function toViewModel(organizations: OrganizationDto[], title?: string): OrganizationView[] | undefined {
  const headOrganizations = organizations.filter(({ parentCode }) => !parentCode);

  return headOrganizations?.length
    ? headOrganizations.map((el) => organizationToViewModel(el, organizations, title))
    : undefined;
}
